import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { smartProfileApi } from '~/api/smartProfile';

type Payload = {
  accounts: {
    platform: string;
    handle: string;
  }[];
};

export type AccountsType = {
  request_id: string;
};

interface GetSCPRequestIdErrorDetail {
  type: string;
  loc: string[];
  msg: string;
  input: string;
  ctx: {
    expected: string;
  };
  url: string;
}

export interface GetSCPRequestIdError {
  detail: GetSCPRequestIdErrorDetail[];
}

export const useSubmitSmartProfileInformation = () => {
  return useMutation<
    AccountsType,
    AxiosError<GetSCPRequestIdError>,
    Payload,
    AccountsType
  >((payload: Payload) => {
    return smartProfileApi
      .post('/smart-profiles/profile-information', { ...payload })
      .then((response) => {
        const { data } = response;
        return data;
      });
  });
};
